import { useMutation } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
export const useConfirmResetPassword = (options) => {
    const { useMutationOptions } = options || {};
    const { client } = useTribeClient();
    return useMutation(input => client.auth.confirmResetPassword(input), useMutationOptions);
};
//# sourceMappingURL=useConfirmResetPassword.js.map